import { RouteConfig } from 'vue-router'

export const prefixRoutes = (prefix: string, routes: RouteConfig[]): RouteConfig[] =>
  routes.map((route) => ({
    ...route,
    path: `${prefix}/${route.path}`,
  }))

export default prefixRoutes
